import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

/**
 * Top navigation for marketing surfaces ({@code /} and {@code /demo}).
 * Transparent over the hero; gains a subtle backdrop after scroll so
 * secondary sections stay readable. Separate from {@code CustomerLayout}
 * (which is auth-aware) and the admin sidebar.
 */
export default function MarketingNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkClass = 'text-sm text-white/80 hover:text-white transition-colors';

  return (
    <header
      className={
        'fixed inset-x-0 top-0 z-50 transition-colors ' +
        (scrolled
          ? 'bg-[#110D09]/90 backdrop-blur supports-[backdrop-filter]:bg-[#110D09]/70 border-b border-white/5'
          : 'bg-transparent')
      }
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4">
        <Link to="/" className="text-lg font-semibold tracking-tight text-white">
          RekPlay
        </Link>

        <nav className="hidden items-center gap-6 md:flex">
          <Link to="/" className={linkClass}>
            Home
          </Link>
          <Link to="/venues" className={linkClass}>
            Venues
          </Link>
          <Link to="/demo" className={linkClass}>
            Demo
          </Link>
          <Link
            to="/login"
            className="text-sm text-white/80 hover:text-white transition-colors"
          >
            Login
          </Link>
          <Link
            to="/demo"
            className="rounded-md bg-[#C2713A] px-4 py-2 text-sm font-medium text-white hover:bg-[#a95f2f] transition-colors"
          >
            Book a demo
          </Link>
        </nav>

        <button
          type="button"
          aria-label="Toggle menu"
          className="rounded-md p-2 text-white/80 hover:bg-white/5 md:hidden"
          onClick={() => setMobileOpen((v) => !v)}
        >
          {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-white/5 bg-[#110D09]/95 px-4 py-4 md:hidden">
          <nav className="flex flex-col gap-3">
            <Link to="/" className={linkClass} onClick={() => setMobileOpen(false)}>
              Home
            </Link>
            <Link to="/venues" className={linkClass} onClick={() => setMobileOpen(false)}>
              Venues
            </Link>
            <Link to="/demo" className={linkClass} onClick={() => setMobileOpen(false)}>
              Demo
            </Link>
            <Link to="/login" className={linkClass} onClick={() => setMobileOpen(false)}>
              Login
            </Link>
            <Link
              to="/demo"
              className="mt-2 rounded-md bg-[#C2713A] px-4 py-2 text-center text-sm font-medium text-white hover:bg-[#a95f2f]"
              onClick={() => setMobileOpen(false)}
            >
              Book a demo
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
